var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00005 12.5798C8.00202 12.7154 7.94771 12.8457 7.85005 12.9398L7.65005 13.1398C7.55617 13.2345 7.42837 13.2877 7.29505 13.2877C7.16174 13.2877 7.03394 13.2345 6.94005 13.1398L1.15005 7.34981C1.05338 7.25908 0.998535 7.1324 0.998535 6.99981C0.998535 6.86723 1.05338 6.74055 1.15005 6.64981L6.94005 0.859813C7.03394 0.765157 7.16174 0.711914 7.29505 0.711914C7.42837 0.711914 7.55617 0.765157 7.65005 0.859813L7.85005 1.05981C7.94771 1.15389 8.00202 1.28423 8.00005 1.41981V3.99981C13.8555 4.10394 18.646 8.69411 19.0001 14.5398C19.0013 14.6607 18.9586 14.7779 18.8801 14.8698C18.7943 14.9531 18.6796 14.9997 18.5601 14.9998H18.4601C18.2193 14.9989 18.0134 14.8266 17.9701 14.5898C17.5001 11.9998 12.7201 9.99981 8.00005 9.99981V12.5798Z",
    fill: "#0599CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.5ca238c104bd4d4cde2973eeb60fb22a.svg";
export { ForwardRef as ReactComponent };